<template>
  <div class="fileUploader">
    <label class="fileUploader__select">
      <VButton v-if="button" text="Dodaj plik..." theme="lightPurple"></VButton>
      <div
        v-else
        :class="['fileUploader__button', { 'fileUploader__button--bolder': value.length > 0 }]"
      >
        <span class="icon-attach" />
        <span v-if="value.length > 0" class="fileUploader__amountLabel">{{ value.length }}</span>
      </div>
      <input
        ref="fileInput"
        type="file"
        class="fileUploader__input"
        :disabled="disabled"
        multiple
        @change="handleFileChange"
      />
      <slot />
    </label>
    <div
      v-if="value.length > 0"
      :class="[
        'fileUploader__files',
        { 'fileUploader__files--absolute': absoluteFileName },
        { 'fileUploader__files--button': button },
      ]"
    >
      <file-uploader-item
        v-for="{ name, type } in value"
        :key="name"
        :name="name"
        :type="type"
        :class="['fileUploader__file', { 'fileUploader__file--button': button }]"
        @removeFile="removeFile(name)"
      />
    </div>
  </div>
</template>

<script>
import FileUploaderItem from '~/components/FileUploaderItem';
import VButton from '@/components/VButton';

export default {
  name: 'FileUploader',
  components: {
    VButton,
    FileUploaderItem,
  },
  props: {
    // eslint-disable-next-line vue/require-prop-types
    value: {
      default: () => [],
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    absoluteFileName: {
      type: Boolean,
      default: false,
    },
    single: {
      type: Boolean,
      default: false,
    },
    button: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    handleFileChange(e) {
      if (this.single) {
        this.$emit('input', [...e.target.files]);
      } else {
        this.$emit('input', [
          ...this.value,
          ...[...e.target.files].filter(targetItem => {
            return !this.value.find(valueItem => valueItem.name === targetItem.name);
          }),
        ]);
      }
    },
    removeFile(name) {
      this.$emit('input', [...[...this.value.filter(item => item.name !== name)]]);
      this.$refs.fileInput.value = [];
    },
  },
};
</script>

<style lang="scss">
.fileUploader {
  $root: &;
  display: flex;
  align-items: center;
  position: relative;
  min-height: 3rem;

  @include rwd('small-tablet') {
    flex-direction: column;
  }

  &:hover {
    #{$root}__button {
      color: $cSec;
    }
  }

  &__select {
    display: flex;
    align-items: center;
    cursor: pointer;
    position: relative;
  }

  &__button {
    color: $cAddNeutral;
    font-size: 2rem;
    position: relative;

    &--bolder {
      color: $cBadgeProm !important;
    }
  }

  &__amountLabel {
    font-size: 0.9rem;
    line-height: 1.1rem;
    font-weight: 800;
    color: $cWhite;
    position: absolute;
    border: 2px solid $cWhite;
    border-radius: 50%;
    height: 1.8rem;
    width: 1.8rem;
    max-width: 1.8rem;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: $cBadgeProm;
    right: -1.2rem;
    top: -1rem;
  }

  &__input {
    position: absolute;
    left: 0;
    top: 0;
    height: 100%;
    width: 100%;
    opacity: 0;
  }

  &__files {
    margin-left: 1.5rem;
    display: flex;

    &--absolute {
      position: absolute;
      left: 100%;
    }

    &--button {
      flex-wrap: wrap;
      margin: 0 -0.5rem;
    }
  }

  &__file {
    margin-right: 1rem;

    &:last-of-type {
      margin-right: 0;
    }

    &--button {
      margin-top: 1rem;
      padding: 0 0.5rem;
    }
  }
}
</style>
